import { createFileRoute } from "@tanstack/react-router";
import {
  bounceToAccountPath,
  haltForExternalNavigation,
} from "../lib/auth/app-origins";

/** Auth UI now lives on account-web — bounce old /register bookmarks. */
export const Route = createFileRoute("/register")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      bounceToAccountPath("/register", window.location.search);
      haltForExternalNavigation();
    }
  },
  validateSearch: (search: Record<string, unknown>): { email?: string; redirect?: string } => ({
    email: typeof search.email === "string" ? search.email : undefined,
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
  }),
  component: () => null,
});
